export enum TransactionStatus {
  PENDING = 'PENDING',
  CALCULATING = 'CALCULATING',
  WON = 'WON',
  LOST = 'LOST',
  VOIDED = 'VOIDED',
}

export enum ResultStatus {
  SUBMITTED = 'SUBMITTED',
  PENDING = 'PENDING',
  WON = 'WON',
  LOST = 'LOST',
  VOIDED = 'VOIDED',
}
